import Vue from 'vue'
import Router from 'vue-router'

// Components 
import ArticuloDetalle from './components/ArticuloDetalle.vue';
import Home from './components/Home.vue';
import Seccion from './components/Seccion.vue';
import Promociones from './components/Promociones.vue';
import Carro from "./components/Carro.vue";
import Checkout from "./components/Checkout.vue";
import Resguardo from "./components/Resguardo.vue"


Vue.use(Router)

const routes = [

	
	{ path: '/', name: 'home', component: Home },
	{ path: '/promotions', name: 'promotions', component: Promociones },
	{ path: '/article/:id', name:'article', component: ArticuloDetalle },
	{ path: '/section/:id', name: 'section', component: Seccion },
	{ path: '/carro', name: 'carro', component: Carro },
	{ path: '/checkout', name: 'carro', component: Checkout },
	{path: '/resguardo', name: 'resguardo', component: Resguardo}

]

export default new Router({
	
	base: process.env.BASE_URL,
	routes
})
